import { addStyles } from 'ethcss'
import { colors, IStyles } from '../../../theme'

const styles: IStyles = {
    modal: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: 600,
        padding: 24,
        borderRadius: 20,
        backgroundColor: colors.white,
        zIndex: 1,
        textAlign: 'center',
    },
    background: {
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    title: {
        fontSize: 22,
        marginBottom: 14,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 30,
    },
    button: {
        margin: '0 5px',
        minWidth: 150,
        display: 'flex',
        justifyContent: 'center',
    },
}

addStyles(styles)
export default styles
